import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { IInventoryItem } from '../../models/inventory.model';
import { InventoryService } from '../../modules/shared/services/inventory/inventory.service';

@Component({
  selector: 'formly-field-input',
  template: `
    <div>
      <div
        class="form-group"
        [ngClass]="(inventoryItems || isLoadingInventoryItems) ? 'mb-0' : ''"
      >
        <label for="exampleInputEmail1">
          Name of product: *
        </label>
        <span class="p-input-icon-right w-100 inventory-search">
          <i
            class="pi pi-times mr-3"
            (click)="clearSearchField()"
            *ngIf="searchText"
          ></i>
          <input
            #searchField
            type="text"
            class="form-control"
            placeholder="Search product by name....e.g. panadol"
            (keypress)="isLoadingInventoryItems = true"
            [formControl]="formControl"
            [formlyAttributes]="field"
            [(ngModel)]="searchText"
          />
        </span>
      </div>
      <div class="card rounded-0" *ngIf="inventoryItems || isLoadingInventoryItems">
        <div class="card-body p-0">
          <div
            class="loading-container d-flex justify-content-center p-2"
            *ngIf="isLoadingInventoryItems"
          >
            <div class="row">
              <div class="col text-right pr-1">
                <i class="fas fa-spinner fa-spin"></i>
              </div>
              <div class="col text-left pl-1">Searching</div>
            </div>
          </div>

          <div *ngIf="!isLoadingInventoryItems">
            <div *ngIf="inventoryItems?.length > 0">
              <div
                class="p-2 border-bottom clickable-patient"
                *ngFor="let inventoryItem of inventoryItems"
                (click)="getSelectedInventoryItem(inventoryItem)"
              >
                {{ inventoryItem?.productName }}
              </div>
            </div>
            <div *ngIf="inventoryItems?.length === 0" class="p-2 border-bottom">
              No search results. Check spelling and try again
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class InventorySearchInputFieldComponent extends FieldType {

  subscriptions = new Subscription();
  searchText: string;
  isLoadingInventoryItems = false;
  @ViewChild('searchField') searchFieldElement: ElementRef;
  selectedInventoryItemFromSearch: IInventoryItem;
  rows = 50;
  defaultPagination = {
    page: 0,
    pageSize: this.rows,
    searchParam: null,
  };
  inventoryItems: IInventoryItem[];
  @Output() selectedProduct = new EventEmitter<IInventoryItem>();
  inventoryItemTypeEnum = {};

  constructor(
    private inventoryService: InventoryService
  ) {
    super();
  }

  clearSearchField(): void {
    // this.searchFieldElement.nativeElement.disabled = false;
    this.searchText = '';
    this.getSearchResults();
    this.selectedInventoryItemFromSearch = null;
  }

  getSearchResults(): void {
    if (this.searchText) {
      this.defaultPagination = {
        ...this.defaultPagination,
        searchParam: this.searchText,
      };
      this.getPaginatedInventoryItems();
    } else {
      this.defaultPagination = {
        ...this.defaultPagination,
        searchParam: null,
      };
      this.inventoryItems = null;
    }
  }

  getPaginatedInventoryItems(): void {
      this.subscriptions.add(
        this.inventoryService
    .getPaginatedInventoryItems(this.defaultPagination)
          .subscribe({
            next: (res) => {
              this.isLoadingInventoryItems = false;
              this.inventoryItems = res.result;
            },
            error: () => this.isLoadingInventoryItems = false
          })
      );
  }

  getSelectedInventoryItem(inventoryItem: IInventoryItem): void {
    this.searchText = JSON.stringify(inventoryItem);
    // this.searchFieldElement.nativeElement.disabled = true;
    this.inventoryItems = null;
    this.selectedInventoryItemFromSearch = inventoryItem;
  }

  ngAfterViewInit(): void {
    fromEvent(this.searchFieldElement.nativeElement, 'input')
      .pipe(map((event: Event) => {
        // this.searchText = (event.target as HTMLInputElement).value;
        return (event.target as HTMLInputElement).value;
      }))
      .pipe(debounceTime(1500))
      .pipe(distinctUntilChanged())
      .subscribe({
        next: (res) => {
          this.getSearchResults();
        },
      });
  }
}
